<template lang="pug">
v-layout.notification(@click='goToItem', align-center)
  v-icon(color='warning', v-if='data.type === "error"') fa fa-exclamation-triangle
  v-icon(color='primary', v-else) fa fa-check

  .timestamp {{ this.data.createdAt | calendarDayTime }}
  .message(v-html='message')
</template>

<script>
const LeaseInfo = {
  BusinessLease: {
    displayName: 'Financial Lease'
  },
  PrivateLease: {
    displayName: 'Krediet'
  }
}

export default {
  props: {
    data: {}
  },

  computed: {
    message () {
      if (this.data.type === 'new_business_lease' || this.data.type === 'new_private_lease') {
        let message = `Je hebt een nieuwe <b>${LeaseInfo[this.data.extra.leaseType].displayName} aanvraag</b> ontvangen via <b>${this.data.extra.websiteName}</b>`

        if (this.data.extra.dealerName) { // TODO nyi in api
          message += ` van <b>${this.data.extra.dealerName}</b>`
        }

        return message
      } else if (this.data.type === 'error') {
        const typeFriendly = this.data.extra.errorType === 'ftp' ? 'FTP' : ''

        return `Er is een <b>${typeFriendly + ' '}</b>fout opgetreden: <b>${this.data.extra.message}</b>`
      }
    }
  },

  methods: {
    goToItem () {
      if (this.data.extra.leaseId) {
        this.$router.push({
          name: 'lease details',
          params: {
            leaseId: this.data.extra.leaseId
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/responsive.scss";

.notification {
  padding: 15px;
  border-top: 1px solid $gray3;
  cursor: pointer;

  @include phone {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  &:nth-child(odd) {
    background: $gray6;
  }

  &:hover {
    background: $gray5;
  }

  .timestamp {
    width: 200px;

    @include phone {
      margin-bottom: 30px;
    }
  }

  .v-icon {
    margin-right: $g;

    @include phablet {
      margin-right: 0;
      margin-bottom: 10px;
    }
  }
}
</style>
